(function () {
  var d = document;
  var root = d.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal on scroll: one pass, elements stay visible once seen */
  var reveals = d.querySelectorAll('.pe-reveal');
  if (reduce || !('IntersectionObserver' in window)) {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    reveals.forEach(function (el) { io.observe(el); });
  }

  /* Header: shadow after scroll, mobile menu */
  var header = d.querySelector('.pe-hd');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 6); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var menu = header.querySelector('.pe-hd__menu');
    var toggle = header.querySelector('.pe-hd__burger');
    if (menu && toggle) {
      var setOpen = function (open) {
        menu.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
        header.classList.toggle('is-open', open);
        root.classList.toggle('pe-lock', open);
      };
      toggle.addEventListener('click', function () { setOpen(menu.hidden); });
      d.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !menu.hidden) { setOpen(false); toggle.focus(); }
      });
      menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setOpen(false); }); });
      var mq = window.matchMedia('(min-width: 1024px)');
      var onMq = function (e) { if (e.matches) setOpen(false); };
      if (mq.addEventListener) mq.addEventListener('change', onMq); else mq.addListener(onMq);
    }
  }

  /* Hero: one orchestrated entrance on load */
  var hero = d.querySelector('.pe-hero');
  if (hero) {
    requestAnimationFrame(function () { requestAnimationFrame(function () { hero.classList.add('is-ready'); }); });
  }

  /* FAQ: only one item open at a time inside a group */
  d.querySelectorAll('[data-accordion]').forEach(function (group) {
    group.addEventListener('toggle', function (e) {
      if (!e.target.open) return;
      group.querySelectorAll('details[open]').forEach(function (other) { if (other !== e.target) other.open = false; });
    }, true);
  });
})();
